import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import httpAdapterInstance from 'configs/HttpAdapterConfig';
import { IBaseResponse } from 'shared/SharedModels';
import { DefaultAPIErrorMsg, ENDPOINTS } from 'shared/constants';
import { IAllJobDetails, IJobInfoState } from './jobs-slice-model';

const initialJobsInfoState: IJobInfoState = {
    getJobDescriptionResponse: '',
    getJobDescriptionStatus: 'idle',
    getJobDetailsStatus: 'idle',
    getJobDetailsResponse: '',
};

export const getJobDescriptionByCode = createAsyncThunk<IBaseResponse, { jobCode: string }, { rejectValue: IBaseResponse }>(
    "getJobDescriptionByCode",
    async ({ jobCode }, { rejectWithValue }) => {
        return await httpAdapterInstance
            .get(`${ENDPOINTS.JOB_DESCRIPTION}/${jobCode}`)
            .then((response: AxiosResponse<IBaseResponse>) => response?.data)
            .catch((error) => {
                throw rejectWithValue(error.response.data);
            });
    }
);

export const getJobDetails = createAsyncThunk<IBaseResponse<IAllJobDetails>, { jobId: string }, { rejectValue: IBaseResponse }>(
    "getJobDetails",
    async ({ jobId }, { rejectWithValue }) => {
        return await httpAdapterInstance
            .get(`${ENDPOINTS.JOBS}/${jobId}`)
            .then((response: AxiosResponse<IBaseResponse<IAllJobDetails>>) => response?.data)
            .catch((error) => {
                throw rejectWithValue(error.response.data);
            });
    }
);

const jobInfoSlice = createSlice({
    name: 'jobsListActions',
    initialState: initialJobsInfoState,
    reducers: {
        resetGetJobDescription: (state) => { state.getJobDescriptionResponse = ''; state.getJobDescriptionStatus = 'idle' },
        resetGetJobDetails: (state) => { state.getJobDetailsStatus = 'idle'; state.getJobDetailsResponse = '' },

    },
    extraReducers: (builder) => {
        // get job desc
        builder.addCase(getJobDescriptionByCode.pending, (state) => {
            state.getJobDescriptionStatus = 'pending'
        });
        builder.addCase(getJobDescriptionByCode.fulfilled, (state, action) => {
            state.getJobDescriptionStatus = 'success';
            state.jobDescription = action.payload.data;
            state.getJobDescriptionResponse = action?.payload?.message ?? DefaultAPIErrorMsg;
        });
        builder.addCase(getJobDescriptionByCode.rejected, (state, action) => {
            state.getJobDescriptionStatus = 'failed';
            state.getJobDescriptionResponse = action?.payload?.message ?? DefaultAPIErrorMsg;
        });
        // get job details
        builder.addCase(getJobDetails.pending, (state) => {
            state.getJobDetailsStatus = 'pending'
        });
        builder.addCase(getJobDetails.fulfilled, (state, action) => {
            state.getJobDetailsStatus = 'success';
            state.jobDetailsInInfo = action.payload.data;

        });
        builder.addCase(getJobDetails.rejected, (state, action) => {
            state.getJobDetailsStatus = 'failed';
            state.getJobDetailsResponse = action?.payload?.message ?? DefaultAPIErrorMsg;
        });
    }
});

export const { resetGetJobDescription, resetGetJobDetails } = jobInfoSlice.actions;
export default jobInfoSlice;
